// src/pages/NotFound.js
import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

function NotFound() {
    return (
      <Container maxWidth="sm">
        <Box sx={{ my: 4, textAlign: 'center', py: 8 }}>
          <ReportProblemIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            404 - Page Not Found
          </Typography>
          <Typography variant="h6" color="text.secondary" paragraph>
            The page you are looking for does not exist or has been moved.
          </Typography>
          <Button component={Link} to="/home" variant="contained" size="large" sx={{ mt: 4 }}>
            Go to Homepage
          </Button>
        </Box>
      </Container>
    );
};

export default NotFound;